// AGC: FloatingActionButton - FAB component for Classic Navy Theme
// AGC: Navy pill button with white icon
import React from 'react'
import { Plus } from 'lucide-react'
import { useTranslation } from '../../hooks/useTranslation'

interface FloatingActionButtonProps {
  onClick: () => void
  icon?: React.ReactNode
  label?: string
  className?: string
}

/**
 * AGC: FloatingActionButton - Navy FAB for Classic Navy Theme
 * AGC: Navy solid button with white icon
 * AGC: Default: Plus icon, positioned bottom-right above BottomNav
 */
export const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({
  onClick,
  icon,
  label,
  className = '',
}) => {
  const { t } = useTranslation()
  return (
    <button
      onClick={onClick}
      className={`
        fixed right-4
        w-14 h-14 rounded-full
        text-white
        shadow-lg
        flex items-center justify-center
        transition-all duration-200
        hover:opacity-90 hover:shadow-xl
        active:scale-95 active:ring-4 active:ring-[var(--ring-click-primary)] active:shadow-xl
        focus:outline-none focus:ring-2 focus:ring-offset-2
        z-[90]
        ${className}
      `}
      style={{
        backgroundColor: 'var(--accent-primary)',
        // AGC: bottom-28 (7rem) + safe-area-inset-bottom so the FAB stays above BottomNav and Android nav bar
        bottom: 'calc(max(env(safe-area-inset-bottom), 0.5rem) + 7rem)',
      }}
      aria-label={label || t('common.addItem')}
    >
      {icon || <Plus className="w-6 h-6" />}
    </button>
  )
}

export default FloatingActionButton
